/**
 * @file 查理宝编辑页面表单验证
 * @author Anker(anker.wang@slicejobs.com)
 * string, number, boolean, method,
 * regexp, integer, float, array,
 * object, enum, date, url, hex, email
 */

import { makeRule } from '@core/utils/rule.js'

export let searchRules = {}

export let taskTplFormRules = {
  title: [
    {...makeRule('请输入模板标题')},
    {...makeRule('长度在1到64个字符'), min: 1, max: 64},
  ],
  detail: [
    {...makeRule('请输入模板描述')},
    {...makeRule('长度在1到256个字符'), min: 1, max: 256},
  ],
}

export let taskFormRules = {
  title: [
    {...makeRule('请输入模板标题')},
    {...makeRule('长度在1到64个字符'), min: 1, max: 64},
  ],
  content: [
    {...makeRule('请输入任务描述')},
  ],
  hirenum: [
    {...makeRule('请输入需要人数', 'integer')},
    {...makeRule('请输入大于0的整数', 'integer'), min: 1},
  ],
  validcheckindistance: [
    {...makeRule('请输入有效签到距离', 'number')},
    {...makeRule('请输入大于0的数值', 'number'), min: 0},
  ],
  processingtime: [
    {...makeRule('请输入完成时限', 'number')},
    {...makeRule('请输入大于0的数值', 'number'), min: 0},
  ],
  reviewtime: [
    {...makeRule('请输入审核周期', 'number')},
    {...makeRule('请输入大于0的数值', 'number'), min: 0},
  ],
  stepTemplateGroups: [
    {...makeRule('请添加分步模板', 'array', 'change')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/clb-task-template/clb-task-template.rules.js